/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedRefetchContainer_viewer$ref = any;
export type SbSharedRefetchContainer_viewer = {
    readonly enableSearchLandingPage: boolean | null;
    readonly " $refType": SbSharedRefetchContainer_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefetchContainer_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "enableSearchLandingPage",
            "name": "isEnabled",
            "args": [
                {
                    "kind": "Literal",
                    "name": "key",
                    "value": "enableSearchLandingPage"
                }
            ],
            "storageKey": "isEnabled(key:\"enableSearchLandingPage\")"
        }
    ]
} as any);
(node as any).hash = '3aa738c0014f1761244d2595d1deb331';
export default node;
